import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import clsx from 'clsx';

interface ShipmentSelectorButtonProps {
  dropdown: {
    totalOptions: number;
    handleOpenOptions: (event: React.MouseEvent<HTMLButtonElement>) => void;
  };
  actions: {
    selectedOption: any;
    copyShipmentNumber: (event?: React.MouseEvent) => void;
  };
}

export const ShipmentSelectorButton: React.FC<ShipmentSelectorButtonProps> = ({ dropdown, actions }) => {
  const { totalOptions, handleOpenOptions } = dropdown;
  const { selectedOption, copyShipmentNumber } = actions;

  return (
    <div className='relative'>
      <strong className='text-12 text-neutral-50 bg-white px-6 absolute -top-10 left-10 z-10'>Select Shipment</strong>
      <div
        className={clsx(
          'relative rounded-8 border border-neutral-40 flex items-center h-40',
          totalOptions > 1 ? 'cursor-pointer hover:border-neutral-50' : 'opacity-50'
        )}
      >
        <div className='h-full flex items-center justify-center relative z-10 w-full'>
          <Tooltip
            arrow
            placement='bottom-start'
            disableInteractive={false}
            enterDelay={500}
            leaveDelay={200}
            title={
              <button
                type='button'
                className='flex items-center'
                onClick={(e) => {
                  e.stopPropagation();
                  copyShipmentNumber(e);
                }}
                onMouseDown={(e) => {
                  e.stopPropagation();
                }}
              >
                <IconButton size='small'>
                  <ContentCopyIcon fontSize='small' className='text-white' />
                </IconButton>
                <span className='text-white ml-8'>Copy Shipment Number</span>
              </button>
            }
            slotProps={{
              popper: {
                sx: {
                  '& .MuiTooltip-arrow': {
                    left: '14px!important',
                    transform: 'none!important',
                  },
                },
              },
            }}
          >
            <button
              type='button'
              onClick={(e) => {
                if (totalOptions >= 2) {
                  handleOpenOptions(e);
                }
              }}
              disabled={totalOptions < 2}
              className='h-full flex-1 flex items-center pl-14 pr-32 relative'
              aria-label='Open options'
            >
              {selectedOption?.valueRender}

              <div className='absolute right-0 top-1/2 transform -translate-y-1/2 text-neutral-40 text-lg'>
                <ArrowDropDownIcon sx={{ fontSize: '28px' }} />
              </div>
            </button>
          </Tooltip>
        </div>
      </div>
    </div>
  );
};
